
const state = {
  id: null,
  options: [],
  provider_code: '',
  provider_id: undefined,
  provider_price_list_id: undefined,
  provider_price_list_item_id: undefined,
  service_product_id: undefined,
}

export const requiredFields = [
  { key: 'provider_code' },
  { key: 'provider_id' },
  { key: 'provider_price_list_id' },
  { key: 'provider_price_list_item_id' },
  { key: 'service_product_id' },
]

export default state
